import React from 'react';
import { Grid, Typography} from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';


function StudyFeatured() {
  const globalClasses = globalUseStyles()
  return (
    <ThemeProvider theme={theme}>
      <Container className={globalClasses.standardContainer} maxWidth={false} component="section">
          <Grid className={globalClasses.containerSmall} container >
            <Grid item xs={12} md={6}  >
                <Typography  variant="subtitle1">Case Study</Typography>
                <Typography  variant="h1">Rosalyn Carter Institute for Caregiving</Typography>
                <div className={globalClasses.tagYellow}>
                  <Typography variant="subtitle2">Custom Application</Typography>
                </div>
                <div className={globalClasses.tagYellow}>
                  <Typography variant="subtitle2">Reporting and Analytics</Typography>
                </div>
            </Grid>
            <Grid item xs={12} md={6} container >
                <Grid item xs={12} md={12} className={globalClasses.stockImg} />
            </Grid>
          </Grid>
      </Container>
    </ThemeProvider>
  );
};

export default StudyFeatured;